var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, html, css } from "lit";
import { customElement } from "lit/decorators.js";
// import EventService from './services/event-service';
// import { env } from './environment/environment';
let PortalMain = class PortalMain extends LitElement {
    static styles = css `
    :host {
      display: flex;
    }
  `;
    render() {
        return html `
    <div class="portal-main">
      <h1>To use this service, obtain a link to a secure TopLine document.</h1>
    </div>
    `;
    }
};
PortalMain = __decorate([
    customElement("portal-main")
], PortalMain);
export { PortalMain };
